import service from '@api/config'

// 查询施工中项目，分页
export const getBuildProjects = (data) => {
  return service.request({
    url: `/project/getBuildProjects`,
    method: 'post',
    data: data
  })
}

// 查询已完结项目，分页
export const getFinishProjects = (data) => {
  return service.request({
    url: `/project/getFinishProjects`,
    method: 'post',
    data: data
  })
}

// 根据项目id查询项目参与人员,分页
export const workersList = (data) => {
  return service.request({
    url: `/bid/workers/list`,
    method: 'post',
    data: data
  })
}

//根据项目id获取施工中项目详情
export const getFinishedProjectInfo = (data) => {
  return service.request({
    url: `/project/getFinishedProjectInfo`,
    method: 'post',
    data: data
  })
}

//删除项目人员
export const workersDel = (data) => {
  return service.request({
    url: `/bid/workers/del`,
    method: 'post',
    data: data
  })
}

// 根据项目id获取施工中项目详情
export const getBuildProjectInfo = (data) => {
  return service.request({
    url: `/project/getBuildProjectInfo`,
    method: 'post',
    data: data
  })
}

// 招标方发起完工
export const completeFinish = (data) => {
  return service.request({
    url: `/project/completeFinish`,
    method: 'post',
    data: data
  })
}

// 投标方发起完工申请
export const finishApply = (data) => {
  return service.request({
    url: `/project/finishApply`,
    method: 'post',
    data: data
  })
}


//--------------------2.0版本--------------------
// 我参与的项目列表
export const myJoinList = (data) => {
  return service.request({
    url: `/project/myJoinList`,
    method: 'post',
    data: data
  })
}

// 我发布的项目列表
export const myPublishList = (data) => {
  return service.request({
    url: `/project/myPublishList`,
    method: 'post',
    data: data
  })
}

// 我参与的 标准流程项目 信息查询，status 0,1
export const getNormalProjectInfo = (data) => {
  return service.request({
    url: `/project/getNormalProjectInfo`,
    method: 'post',
    data: data
  })
}

// 开始施工
export const beginBuild = (data) => {
  return service.request({
    url: `/project/beginBuild`,
    method: 'post',
    data: data
  })
}

// 库中人员添加到项目中
export const workersChoose = (data) => {
  return service.request({
    url: `/bid/workers/choose`,
    method: 'post',
    data: data
  })
}

// 我参与的 简易流程项目 信息查询
export const getSimpleProjectInfo = (data) => {
  return service.request({
    url: `/project/getSimpleProjectInfo`,
    method: 'post',
    data: data
  })
}

// 根据简易项目id获取完工情况
export const getFinishStatus = (data) => {
  return service.request({
    url: `/project/getFinishStatus`,
    method: 'post',
    data: data
  })
}

// 删除我发布的简易项目
export const delProject = (data) => {
  return service.request({
    url: `/project/del`,
    method: 'post',
    data: data
  })
}

// 我发布的 根据id获取获取简易项目信息
export const getProjectPubInfo = (data) => {
  return service.request({
    url: `/project/getProjectPubInfo`,
    method: 'post',
    data: data
  })
}

// 我发布的 分页获取简易项目报名人员
export const getProjectSigns = (data) => {
  return service.request({
    url: `/project/getProjectSigns`,
    method: 'post',
    data: data
  })
}

// 我发布的 分页获取简易项目签约人员
export const getProjectAccepts = (data) => {
  return service.request({
    url: `/project/getProjectAccepts`,
    method: 'post',
    data: data
  })
}

// 同意签约
export const agreeAccept = (data) => {
  return service.request({
    url: `/project/agreeAccept`,
    method: 'post',
    data: data
  })
}

// 查询库中还未选择到项目人员,分页
export const workersSelect = (data) => {
  return service.request({
    url: `/project/workers/select`,
    method: 'post',
    data: data
  })
}

//  我发布的 简易项目查看签约人员详细信息
export const getAcceptDetail = (data) => {
  return service.request({
    url: `/project/getAcceptDetail`,
    method: 'post',
    data: data
  })
}

//  我发布的 简易项目查看报名人员详细信息
export const getSignDetail = (data) => {
  return service.request({
    url: `/project/getSignDetail`,
    method: 'post',
    data: data
  })
}

//  我发起的 简易项目发起完工
export const simpleFinish = (data) => {
  return service.request({
    url: `/project/simple/finish`,
    method: 'post',
    data: data
  })
}

//  我发布的简易项目，已招满操作
export const userEnough = (data) => {
  return service.request({
    url: `/project/userEnough`,
    method: 'post',
    data: data
  })
}

//  我发布的 获取是否已进行过中期评价
export const getMidAssessStatus = (data) => {
  return service.request({
    url: `/project/getMidAssessStatus`,
    method: 'post',
    data: data
  })
}

//  我发布的 获取是否已进行过完工评价
export const getFinishAssessStatus = (data) => {
  return service.request({
    url: `/project/getFinishAssessStatus`,
    method: 'post',
    data: data
  })
}

//  我发布的 简易同意完工
export const simpleAgreeFinish = (data) => {
  return service.request({
    url: `/project/simpleAgreeFinish`,
    method: 'post',
    data: data
  })
}

//  获取流标信息原因
export const failReason = (data) => {
  return service.request({
    url: `/project/failReason`,
    method: 'post',
    data: data
  })
}

// 判断接活状态
export const getProjectAcceptFlag = (data) => {
  return service.request({
    url: `/project/getProjectAcceptFlag`,
    method: 'post',
    data: data
  })
}

// 撤销
export const changeCancel = (data) => {
  return service.request({
    url: `/project/change/cancel`,
    method: 'post',
    data: data
  })
}

// 修改获取项目信息
export const getNormalInfo = (data) => {
  return service.request({
    url: `/project/change/getNormalInfo`,
    method: 'post',
    data: data
  })
}

// 修改保存
export const changeSave = (data) => {
  return service.request({
    url: `/project/change/save`,
    method: 'post',
    data: data
  })
}

// 项目进度
export const getProjectProgress = (data) => {
  return service.request({
    url: `/project/getProjectProgress`,
    method: 'post',
    data: data
  })
}

// 项目浏览记录
export const getProjectBrowse = (data) => {
  return service.request({
    url: `/project/getProjectBrowse`,
    method: 'post',
    data: data
  })
}

// 查询我发布的项目数和我参与的项目数
export const getMyProjectCount = (data) => {
  return service.request({
    url: `/project/getMyProjectCount`,
    method: 'post',
    data: data
  })
}

// 查询是否包含敏感词
export const illegalWordsCheck = (data) => {
  return service.request({
    url: `/common/illegalWordsCheck`,
    method: 'post',
    data: data
  })
}

// 查询关联工种
export const typeOfWorkMatch = (data) => {
  return service.request({
    url: `/common/typeOfWorkMatch`,
    method: 'post',
    data: data
  })
}
